import React, { useEffect, useState } from "react";
import sanityClient from "../client";
import NavBar from "./NavBar";
import NavBarMobile from "./NavBarMobile";
import { useMediaQuery } from "@uidotdev/usehooks";
import Form from "./Form";
import Footer from "./Footer";

export default function Report() {
  const isSmallDevice = useMediaQuery("only screen and (max-width: 768px)");
  const allDevices = useMediaQuery("only screen and (min-width: 769px)");

  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "report"] | order(_createdAt desc){
      _id,
      naslov,
      opis,
      link,
      dugme
    }`,
      )
      .then((data) => {
        console.log("SANITY REPORT DATA:", data);
        setReportData(data);
      })
      .catch(console.error);
  }, []);
  return (
    <>
      {allDevices && <NavBar />}
      {isSmallDevice && <NavBarMobile />}

      <main className="bg-white-100 min-h-screen p-12">
        <section className="container max-w-screen-xl mx-auto">
          <h1 className="text-4xl flex justify-center pb-4">
            EXTREMES tehnički izveštaji
          </h1>

          <section className="grid grid-cols-1 gap-4">
            {reportData.length > 0 ? (
              reportData.map((report) => (
                <article
                  className="relative pt-2 pb-4 border-b border-gray-200"
                  key={report._id}
                >
                  <h3 className="text-blue-600 text-2xl hover:text-blue-700">
                    {report.naslov}
                  </h3>

                  <p className="text-gray-700 py-4 dark:text-gray-400 mb-2">
                    {report.opis}
                  </p>

                  <a
                    href={report.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 rounded"
                  >
                    {report.dugme}
                  </a>
                </article>
              ))
            ) : (
              <p className="text-gray-500 text-center">
                Nema dostupnih izveštaja ili se još učitavaju...
              </p>
            )}
          </section>
        </section>
      </main>

      <Form />
      <Footer />
    </>
  );
}
